module.exports = __webpack_public_path__ + "img/LogoEndaTao.25ae0392.png";